/*
    Dashboard.js -
 */

import {Rest} from '@/paks/js-rest'
import {State} from '@/paks/vu-state'
import {cleanBoard} from '@/paks/vu-dash/BoardUtils'

const Dashboard = new Rest(
    'Dashboard',
    {
        // DEPRECATED
        clean: (dashboard, onRead = false) => {
            return cleanBoard(dashboard, onRead)
        },
        getCurrent: async () => {
            /*
                Handle first time setup and create a default dashboard if required
            */
            let dashboard
            let name = State.config.features?.dash?.name
            if (name == 'auto') {
                let name = window.innerWidth <= 640 ? 'Mobile' : 'Desktop'
                dashboard = State.get('Dashboard', name)
            } else if (name) {
                dashboard = State.get('Dashboard', name)

            } else if (State.cache.dashboard?.name) {
                dashboard = State.get('Dashboard', State.cache.dashboard.name)
            }
            if (!dashboard) {
                dashboard = State.get('Dashboard', 'Default')
            }
            if (!dashboard) {
                if (State.cache.dashboards.length > 0) {
                    dashboard = State.cache.dashboards[0]
                } else {
                    dashboard = await Dashboard.create({name: 'Default'})
                }
            }
            State.cache.dashboard = dashboard
            return dashboard
        },
        set: async (dashboard) => {
            if (!dashboard) {
                State.cache.dashboard = {}
                dashboard = await Dashboard.getCurrent()
                return
            }
            let dashboards = State.cache.dashboards
            let index = dashboards.findIndex((d) => d.id == dashboard?.id)
            if (index < 0) {
                index = dashboards.length
            }
            dashboards[index] = State.cache.dashboard = dashboard
        },
        setByName: async (name) => {
            let dashboard = State.cache.dashboards.find((d) => d.name == name)
            if (dashboard) {
                await Dashboard.set(dashboard)
            }
        },
    },
    {
        cache: true,
        service: () => State.config.builder ? '/api' : '',
        callback: async (reason, args) => {
            if (reason == 'before') {
                if (args.action == 'create' || args.action == 'update') {
                    args.fields = cleanBoard(args.fields, false)
                }
            } else if (reason == 'after') {
                args.fields = cleanBoard(args.fields, true)
            }
        }
    }
)

export default Dashboard
